export const getCareInstructions = ({ descriptors }) => {
  return (descriptors || []).find((desc) => desc.heading.match(/Care/));
};

export const getOtherDescriptors = ({ descriptors, careInstructions }) => {
  return (descriptors || []).filter((desc) => {
    if (careInstructions) {
      return desc.heading !== careInstructions.heading;
    }

    return desc.descriptiveAttributes || desc.description;
  });
};
